<template>
  <v-card
    class="my-3"    
    style="background-color: rgb(var(--v-theme-contained))"
    variant="elevated"
    elevation="2"
    width="100%"
    @click="$emit('navigate', nested)"
  >
    <v-card-title>{{nested.name}}</v-card-title>
    <v-card-text>
      <v-list>
        <v-list-item v-for="(info, index) in flattened.slice(0, 5)" :key="index" style="padding-top: 0; padding-bottom: 0; min-height: fit-content;">
          <SymbolText :id="info.id" :prefix="`${info.name}: `" />
          <!-- {{info.name}}: {{attribute(info.id)?.value}} -->
        </v-list-item>
      </v-list>
    </v-card-text>
    
    <!-- Bottom right chevron icon -->
    <v-btn icon class="bottom-right">
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </v-card>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, onUnmounted } from "vue";
import type { BubblyItem } from "@lr-notitia/bubbly-d3";
import { flattenStructure } from "../../../../composables/bubblyPathCalculator";
import { useGraphStore } from "../../../../store/graph";
import SymbolText from "./SymbolText.vue";

const compProps = defineProps<{
	nested: BubblyItem
}>();
defineEmits(["navigate"]);

const flattened = computed(() => {
  return flattenStructure(compProps.nested)
})

const graphStore = useGraphStore();
const attribute = computed(() => {
	return (id:string) => graphStore.instance.attribute.byId(id);
});
</script>

<style scoped>
.bottom-right {
  position: absolute;
  bottom: 16px;
  right: 16px;
}
</style>